// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';

const StyledActivatedCell = styled.td`
  text-align: center;
  background: ${({ activated }) => (activated ? '#66DDAA' : 'inherit')};
  color: ${({ activated }) => (activated ? '#ffffff' : 'inherit')};
`;

const FareharborItemsList = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  items,
}) => (
  <div>
    <Table hover>
      <thead>
        <tr>
          <th>Activated</th>
          <th>PK</th>
          <th>Name</th>
          <th>Company Shortname</th>
          <th>Created At</th>
          <th>Updated At</th>
          <th>Deleted At</th>
        </tr>
      </thead>
      <tbody>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {items.map(item => (
          <tr key={item.pk}>
            <StyledActivatedCell activated={!!item.activityId}>
              {item.activityId ? 'Yes' : 'No'}
            </StyledActivatedCell>
            <td>{item.pk}</td>
            <td>{item.name}</td>
            <td>{item.company_shortname}</td>
            <td>{item.createdAt}</td>
            <td>{item.updatedAt}</td>
            <td>{item.deletedAt}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

export default FareharborItemsList;
